import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { TextBlockPickerModule } from '../../../../app/atoms/text-block-picker/text-block-picker.module';
import { RichTextControlModalComponent } from './rich-text-control-modal.component';
import { RichTextControlComponent } from './rich-text-control.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        TextBlockPickerModule
    ],
    declarations: [
        RichTextControlComponent,
        RichTextControlModalComponent
    ],
    exports: [
        RichTextControlComponent
    ],
    entryComponents: [
        RichTextControlModalComponent
    ]
})
export class RichTextControlModule {
}



// WEBPACK FOOTER //
// ./src/vas/controls/rich-text/form/rich-text-control.module.ts